<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    components: {},
    props: {},

    data () {
      return {
        form: {
          username: '',
          password: '',
          isShown: false,
        },
      }
    },

    computed: {
      ...mapState('user', [
        'name',
        'mail',
        'uid',
      ]),
      ...mapGetters('user', [
        'isLoggedIn'
      ]),
    },

    watch: {
      isLoggedIn (isLoggedIn) {
        if (!isLoggedIn) {
          const { form } = this.$options.data()
          this.form = form
        }
      },

      'form.isShown' (isShown) {
        this.$nextTick(() => {
          const element = this.$refs.input_username
          if (isShown && element) {
            element.select()
          }
        })
      },
    },

    created () {
      // this.watchUserAuthStateChange()
    },

    mounted () {
    },

    beforeDestroy () {
    },

    methods: {
      ...mapActions('user', [
        'watchUserAuthStateChange',
        'login',
        'logout',
      ]),
    },

    filters: {
    },
  }
</script>


<template>
  <div class="User" v-if="false">
    <button v-if="isLoggedIn" @click="logout()">Logout</button>
    <button v-else-if="!form.isShown" @click="form.isShown = true">Login</button>
    <form v-else @submit.prevent="login(form)" @keydown.esc="form.isShown = false">
      <input type="text"     v-model="form.username" ref="input_username" value="" placeholder="foo@example.com">
      <input type="password" v-model="form.password" ref="input_password" value="" placeholder="password">
      <button type="submit">GO</button>
    </form>
  </div>
</template>


<style lang="scss">
  @import '~@/stylesheets/common';

  .User {
    position: absolute;
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;

    @include iroha-vw-range($to: strip-unit($device-width--tab)) {
      right: $size-unit * 5;
      top: $size-unit * 8;
    }

    @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
      right: $size-unit * 10;
      top: $size-unit * 16;
    }

    form {
      margin: 0;
      padding: 0;
    }

    input,
    button {
      margin: 0;
      padding: 0.25em;
      font-size: inherit;
      line-height: 1;

      &:not(:first-child) {
        margin-left: $size-unit * 2;
      }
    }

    button {
      padding-left: 1em;
      padding-right: 1em;
      line-height: 1.5;
    }
  }
</style>
